import React, { useEffect, useState } from 'react'
import TorchEffect from '../../../components/torchEffect/TorchEffect';
import { Button, Modal, UploadingInput } from '../../../components/common';
import { ReactComponent as Close } from "../../../assets/icons/close-circle.svg";
import { ReactComponent as Success } from "../../../assets/icons/success-confity.svg";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";
import { useGetTraderDataQuery, useUpdateTradeLicenseMutation } from '../../../store/Company/companyApiSlice';
import { uploadFileToS3 } from '../../../utils/uploadFileToS3';
import { uploadFilePath } from '../../../constants/s3UploadPath';
import { useParams } from 'react-router-dom';

function TradeLicence() {
    const param = useParams()
    const fileToken = param.token || "";
    const [errors, setErrors] = useState({});
    const [uploadedFile, setUploadedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [progress, setProgress] = useState(20);
    const [isFileUpload, setIsFileUpload] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [apiError, setApiError] = useState("");
    const [uploadSuccess, setUploadSuccess] = useState(false)
    const [updateTradeLicense] = useUpdateTradeLicenseMutation();
    const { data: tokenData } = useGetTraderDataQuery({ fileToken })

    useEffect(() => {
        if (!uploadedFile) {
            setIsFileUpload(false)
        }
    }, [uploadedFile])

    function renderPreview() {
        if (uploadedFile.type.includes("image")) {
            // NOTE: ADD YOUR TRADE LICENCE CERTIFICATE FROM TRADE LICENCE API ON BELOW LINE
            return <img src={previewImage} alt="trade" className="w-18" />;
        } else if (uploadedFile.type === "application/pdf") {
            return (
                <embed
                    src={`${URL.createObjectURL(uploadedFile)}#page=1`}
                    type="application/pdf"
                    width="100%"
                    height="500px"
                />
            );
        } else {
            return <p>Unsupported file</p>;
        }
    };

    const handleFileSelect = (file) => {
        setUploadedFile(file);
        if (file && file.type.match("image.*") || file.type.match("application/pdf")) {
            errors.tradePhotoError = "";
            const reader = new FileReader();

            reader.onload = (e) => {
                setPreviewImage(e.target.result);
            };

            reader.readAsDataURL(file);
            setErrors(errors);
        } else {
            setPreviewImage(null);
            errors.tradePhotoError = "Please upload your trade license jpg or pdf";
            setErrors(errors);
        }
        setIsFileUpload(true)
    };

    function convertFileSize(size) {
        if (size < 1024) {
            return size + " B";
        } else if (size < 1024 * 1024) {
            return (size / 1024).toFixed(2) + " KB";
        } else {
            return (size / (1024 * 1024)).toFixed(2) + " MB";
        }
    }

    const handleFileUpload = async () => {
        setIsLoading(true)
        try {
            const res = await uploadFileToS3(
                uploadFilePath?.tradeLicense,
                uploadedFile,
                "",
                fileToken,
                fileToken
            );
            if (res.url) {
                const data = {
                    token: fileToken,
                    trade_license: res.url,
                }
                const response = await updateTradeLicense({ data });
                if (response?.error) {
                    setApiError(response.error.data.message || "Failed to update trade license, Please Contact support at support@trevex.io")
                }
                else if (response?.data?.token) {
                    setUploadSuccess(true)
                }
            } else if (res?.error) {
                setApiError(res?.error || "Failed to update trade license, Please Contact support at support@trevex.io")
            }
        } catch (error) {
            setApiError(error.message || error.error || "Failed to update trade license, Please Contact support at support@trevex.io")
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="w-full h-full ">
            <Modal noClose>
                {/* <TorchEffect whiteBG autoHeight style={{ backgroundColor: "rgba(0,0,0,0.4)", width: "600px" }}> */}
                <div className='w-[300px] sm:w-[400px] md:w-[600px] '>
                    {uploadSuccess ? <div className='flex flex-col justify-center items-center'>
                        <Success className="mt-4" />
                        <div className='text-center p-4'>
                            <p className='text-[31px] font-bold mb-1'>Update Request Received!</p>
                            <p className='text-[12px] text-[#787878]'>{`We’ve received your trade license and will update your company profile; you’ll be notified once the update for ${tokenData?.company_name} is complete.`}</p>
                            <p className='text-link text-[12px] font-bold mt-1'>You can now close this tab</p>
                        </div>
                    </div> : <div className='flex flex-col justify-center items-center py-2 lg:px-0'>
                        <div className='w-full text-left mb-3'>
                            <h1 className='text-[24px] font-bold'>Upload Your Trade License</h1>
                            <h2 className='text-[12px] text-[#787878]'>{`Please provide the latest trade license for ${tokenData?.company_name}.`}</h2>
                        </div>
                        <div className='w-full max-w-[1280px] m-auto'>
                            <label
                                className="block mb-1 text-primary text-f14 font-semibold text-left"
                            >
                                Upload Trade License*
                            </label>
                            {!uploadedFile && <UploadingInput
                                onFileSelect={handleFileSelect}
                                isUploading={isLoading}
                                uploadedFile={uploadedFile}
                            // uploadError={}
                            />}
                            {uploadedFile && (
                                <div className="bg-slate mt-2 p-3 rounded-md relative ">
                                    <div className="flex gap-3">
                                        <div
                                            className={`flex-auto w-16 ${uploadedFile.type === "application/pdf"
                                                ? "h-20"
                                                : "h-14"
                                                } overflow-hidden`}
                                        >
                                            {renderPreview()}
                                        </div>
                                        <div className="flex flex-col items-start justify-center text-secondarytwo">
                                            <p className="text-f14">{uploadedFile.name}</p>
                                            <div>
                                                <span className="text-f12 text-secondary">
                                                    {convertFileSize(uploadedFile.size)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {isLoading && (
                                        <div className="flex gap-3 items-center justify-start mt-3">
                                            <div className="bg-white h-2 rounded-full overflow-hidden  relative w-full">
                                                <div
                                                    className="bg-primary h-full transition-all"
                                                    style={{ width: `${progress}%` }}
                                                ></div>
                                            </div>
                                            <span className="">{progress}%</span>
                                        </div>
                                    )}

                                    {uploadedFile && (
                                        <button
                                            className="absolute right-3 top-3"
                                            onClick={() => {
                                                setUploadedFile(null);
                                                setPreviewImage(null);
                                                setApiError("");
                                                setErrors({});
                                            }}
                                        >
                                            <Close />
                                        </button>
                                    )}
                                </div>
                            )}
                            {apiError && <p className='text-left text-[12px] text-red-500'>{apiError}</p>}
                            <div className='w-full flex justify-end'>
                                <Button onClick={(isFileUpload && !isLoading) ? () => handleFileUpload() : null} classes={`mt-2 px-4 py-2 text-white text-base rounded ${(isFileUpload && !isLoading) ? "bg-primary cursor-pointer" : " bg-disable cursor-not-allowed"}`}>{isLoading ? <div className='flex gap-1 items-center justify-center'><Spinner />Uploading</div> : "Upload Trade License"}</Button>
                            </div>
                        </div>
                    </div>}
                </div>
                {/* </TorchEffect> */}
            </Modal>
        </div>
    );
}

export default TradeLicence